import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "results" }
const _hoisted_2 = { class: "results__text" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 1,
  class: "results__check"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.singleMessages, (msg) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "results__row",
        key: msg.text
      }, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(msg.text), 1),
        (msg.text)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              onClick: ($event: any) => (_ctx.onCopy(msg)),
              class: "results__copy"
            }, "Copy", 8, _hoisted_3))
          : _createCommentVNode("", true),
        (msg.copied)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, "✓"))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}